import { UNPROCESSABLE_ENTITY } from '@mm/constants/status-codes';
import { getErrorJson } from '@mm/utils';
import { Dispatch } from 'redux';
import UsersCRUDActions from '../actions/UsersCRUDActions';
import modalActions from '../modules/modalsState/actions';
import { StoreState } from '../store-interfaces';
import commonHandler, { ResponseOrError } from './common-handler';

export const userHandler =
  (dispatch: Dispatch<StoreState>) =>
  async (error: ResponseOrError, action?: string) => {
    if (
      error instanceof Response &&
      error.status === UNPROCESSABLE_ENTITY &&
      action === UsersCRUDActions.updateAction
    ) {
      const responseErrorBody = await getErrorJson(error);
      const errorMessage = responseErrorBody.errors;

      dispatch(
        modalActions.openPrettyErrorModal({
          title: '',
          errorMessage,
        }),
      );
      dispatch(UsersCRUDActions.unbusy());
    } else {
      await commonHandler(dispatch)(error);
    }
  };
